<template>
    <div id="asset_group_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehiclegroupHeader" v-if="$route.params.id > 0">Update Asset Group</span>
                    <span class="page-title" id="vehiclegroupHeader" v-else>Add Asset Group</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleGroupList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-group-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VehicleGroupForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Asset Group Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Asset Group Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="year">Year:</label>
                                        <input type="text" class="form-control" v-model="year" id="year" placeholder="Enter Asset Group Year" name="year" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{year_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="manufacturer_code">Manufacturer</label>
                                        <v-select v-model="manufacturer_code" name="manufacturer_code" placeholder="Select Manufacturer."
                                                label="text"
                                                :options="manufacturercodeArr" id="manufacturer_code">
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="model_code">Model</label>
                                        <v-select v-model="model_code" name="model_code" placeholder="Select Model."
                                                label="text"
                                                :options="modelcodeArr" id="model_code">
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vehicle_type_code">Asset Type</label>
                                        <v-select v-model="vehicle_type_code" name="vehicle_type_code" placeholder="Select Asset Type."
                                                label="text"
                                                :options="vehicletypecodeArr" id="vehicle_type_code">
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="year">Estimated Life (Miles):</label>
                                        <input type="text" class="form-control" v-model="estimatedLife" id="estimated_life" placeholder="Enter Estimated Life" name="estimated_life" @keypress="isIntegerCheck($event)">
                                    </div>
                                    <div style="clear:both"></div>
                                    <div class="col form-group">
                                        <div class="custom-checkbox">
                                            <label class="control-label" for="vehicle_type_code"></label><br>
                                            <label for="statusCheckBox" class="checkbox-custom"> Is Active
                                                <input type="checkbox" v-model="statusCheckBox" id="statusCheckBox" name="statusCheckBox" v-on:click="checkSelected($event)">
                                                <span class="checkmark"></span>
                                            </label>
                                            <div class="field-error"></div>
                                        </div>
                                    </div>
                                </div>
                                <hr class="light-hr"/>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label"> Warranty</label><br>
                                        <!-- <v-select v-model="warranties" name="warranties" placeholder="Select Warranty."
                                                    label="text" class="close-remove"
                                                    :options="warrantyArr" id="warranties" @input="onWarrantySelect($event)">
                                        </v-select> -->
                                        <v-select v-model="warranties" name="warranties"
                                                label="text" :filterable="false" :options="warrantyArr"
                                                @search="onSearchWarranty" @change="onWarrantySelect($event)"
                                                placeholder="Select Warranty" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Warranty...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <template v-if="selectedWarranties.length > 0">
                                            <template v-for="(data, index) in selectedWarranties">
                                                <div :key="index" class="file-container">
                                                    <span class="fileupload-preview">{{data.text}}</span>
                                                    <i :key="'add-remove'+index" v-on:click="removeWarranty($event,index)" class="fp-remove color-red cursor-pointer"></i>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label"> Program</label><br>
                                        <v-select v-model="program_id" name="program_id" placeholder="Select Program."
                                                    label="text" class="close-remove"
                                                    :options="programArr" id="program_id">
                                        </v-select>
                                    </div>
                                </div>
                                <hr class="light-hr"/>
                                <h5 class="color-blue"> Features </h5>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <template v-for="(feature, index) in featureArr">
                                        <div class="col form-group" :key="index">
                                            <label class="control-label" for="feature">{{feature.text}} :</label>
                                            <input type="text" class="form-control" v-model="feature.value" id="feature" placeholder="" >
                                        </div>
                                    </template>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" v-if="$route.params.id > 0" id="createVehicleGroupBtn" class="btn btn-primary" v-on:click.prevent="CreateVehicleGroup" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" v-else id="createVehicleGroupBtn" class="btn btn-primary" v-on:click.prevent="CreateVehicleGroup" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" v-if="$route.params.id == undefined" id="createAndContinueVehicleGroupBtn" class="btn btn-tertiary" v-on:click.prevent="CreateVehicleGroup(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelVehicleGroupBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehicleGroupList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
  name: "VehicleGroupCreate",
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Asset Group | " +process.env.COPYRIGHT_NAME : "Create Asset Group | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    estimatedLife:"",
    isEdit:false,
    permissions: [],
    cantAccessPage: "",
    name: "",
    code: "",
    year: "",
    manufacturer_code: null,
    manufacturercodeArr: [],
    model_code: null,
    modelcodeArr: [],
    vehicle_type_code: null,
    vehicletypecodeArr: [],
    statusValue: 1,
    statusCheckBox: "1",
    loading:false,
    name_error_msg: "",
    code_error_msg: "",
    year_error_msg: "",
    warrantyArr:[],
    warranty:"",
    warranties:null,
    selectedWarranties:[],
    renderComponent: false,
    featureLines:[],
    featureArr:[],
    groupId:"",
    programArr:[],
    program_id:'',
  }),
  watch: {

      //check permission change
      permissions: function (permissions) {
          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'add_asset_group') {
                      self.cantAccessPage = true;
                  }
              }
          }

      },
      manufacturer_code: function(manufacturer_code) {

        var self = this;
        if(self.manufacturer_code == null){
            self.model_code = null;
            self.modelcodeArr = [];
            return;
        }
        $.ajax({
            url: process.env.ROOT_API + "/assetmodel/search",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                id:manufacturer_code.value,
            },
            success: function (data) {
                 //if data is edit than dont make model id blank
                if ( !self.isEdit ) {
                    self.model_code = "";
                }
                self.isEdit = false;
                if (data.status == "success") {

                    self.modelcodeArr = data.content.vehiclemodels;
                    // self.model_code = "";
                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'asset-group-model-search')
            }
        });
    }
  },
  created: function() {

  },
  mounted: function() {

        var self = this;

        self.getPermissions();
        self.loadVehicleGroupData();

        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
            self.groupId = segments[3];
            self.loadVehicleGroup();
        }else{
            self.loadExtraFeatures();
        }
        self.loadFieldData(['program','warranty']);

  },
  methods: {
    onSearchWarranty(search, loading) {

        var self = this;
        if (search.length > 1) {
            loading(true);
            self.searchField(loading, search, 'warranty', '');

        }
    },

    BackVehicleGroupList() {
      var self = this;
      self.$router.push("/assetgroup/list");
    },


    loadVehicleManufacturer() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/assetmanufacturer/search",
           type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            success: function (data) {
                //console.log(data.content.email);
                if (data.status == "success") {

                    self.manufacturercodeArr = data.content;
                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'asset-group-manufacturere-search')
            }
        });
    },

    loadVehicleModel() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/assetmodel/search",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            success: function (data) {
                //console.log(data.content.email);
                if (data.status == "success") {

                    self.modelcodeArr = data.content;
                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'asset-group-assetmodel-search')
            }
        });
    },

    loadVehicleType() {

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/assettype/search",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            success: function (data) {
                //console.log(data.content.email);
                if (data.status == "success") {

                    self.vehicletypecodeArr = data.content;
                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'asset-group-type-search')
            }
        });
    },
      checkSelected: function(e) {
          var self = this;
          if (e.target.checked) {

              self.statusValue = 1;
          }else{
              self.statusValue = 0;
          }
      },

    CreateVehicleGroup(flag) {
      var self = this;
      var error = false;

      self.code = self.code.trim();
      self.name = self.name.trim();

      self.name_error_msg = "";
      self.code_error_msg = "";
      self.year_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
        error = true;
      }

      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code Required.";
        error = true;
      }
      if (!self.year || self.year == null || self.year == "") {
        self.year_error_msg = "Year Required.";
        error = true;
      }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehicleGroupBtn").val("Updating ...");
                $("#createVehicleGroupBtn").prop("disabled", true);
                $("#cancelVehicleGroupBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehicleGroupBtn").val("Saving ...");
                    $("#createVehicleGroupBtn").prop("disabled", true);
                    $("#createAndContinueVehicleGroupBtn").prop("disabled", true);
                    $("#cancelVehicleGroupBtn").prop("disabled",true);

                } else{

                    $("#createVehicleGroupBtn").val("Saving ...");
                    $("#createVehicleGroupBtn").prop("disabled", true);
                    $("#createAndContinueVehicleGroupBtn").prop("disabled", true);
                    $("#cancelVehicleGroupBtn").prop("disabled",true);
                }
            }

            var fields = $("#VehicleGroupForm").serializeArray();

              if(self.featureArr.length > 0)
              {
                  fields.push({name:"extra_features",value:JSON.stringify(self.featureArr)});
              }else{
                  fields.push({name:"extra_features",value:''});
              }

            if(self.manufacturer_code == null){
                fields.push({name: "vehicle_manufacturer_code", value: ""});
            }else{
                fields.push({name: "vehicle_manufacturer_code", value: self.manufacturer_code.value});
            }

            if(self.model_code == null){
                fields.push({name: "vehicle_model_code", value: ""});
            }else{
                fields.push({name: "vehicle_model_code", value: self.model_code.value});
            }
            if(self.vehicle_type_code == null){
                fields.push({name: "vehicle_type_id", value: ""});
            }else{
                fields.push({name: "vehicle_type_id", value: self.vehicle_type_code.value});
            }

            fields.push({ name: "id", value: segments[3] });
            fields.push({ name: "statusCheckBox", value: self.statusValue });
            // if(self.warranty != "" && self.warranty.length > 0){
            //     fields.push({ name: "warranties", value: JSON.stringify(self.warranty)});
            // }else{
            //     fields.push({ name: "warranties", value: ""});
            // }
            if(self.selectedWarranties != "" && self.selectedWarranties.length > 0){
                fields.push({ name: "warranties", value: JSON.stringify(self.selectedWarranties)});
            }else{
                fields.push({ name: "warranties", value: ""});
            }

            if(self.program_id == null){
                fields.push({name: "program_id", value: ""});
            }else{
                fields.push({name: "program_id", value: self.program_id.value});

            }

            $.ajax({
                url: process.env.ROOT_API + "/assetgroup/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleGroupBtn").val("Update");
                        $("#createVehicleGroupBtn").prop("disabled", false);
                        $("#cancelVehicleGroupBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleGroupBtn").val("Save and Continue");
                            $("#createVehicleGroupBtn").prop("disabled", false);
                            $("#createAndContinueVehicleGroupBtn").prop("disabled", false);
                            $("#cancelVehicleGroupBtn").prop("disabled",false);

                        } else{

                            $("#createVehicleGroupBtn").val("Save");
                            $("#createVehicleGroupBtn").prop("disabled", false);
                            $("#createAndContinueVehicleGroupBtn").prop("disabled", false);
                            $("#cancelVehicleGroupBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#VehicleGroupForm").trigger("reset");
                            self.name = "";
                            self.year = "";
                            self.code = "";
                            self.statusValue = "";
                            self.statusCheckBox = "";
                            self.manufacturer_code = null;
                            // self.manufacturercodeArr = "";
                            self.model_code = null;
                            // self.modelcodeArr = "";
                            self.vehicle_type_code = null;
                            self.warranty = "";
                            self.warranties = null;
                            self.program_id = '';
                            self.selectedWarranties = [];
                            // self.vehicletypecodeArr = "";

                        } else{
                            self.$router.push("/assetgroup/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleGroupBtn").val("Update");
                        $("#createVehicleGroupBtn").prop("disabled", false);
                        $("#cancelVehicleGroupBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#VehicleGroupForm").trigger("reset");
                            $("#createAndContinueVehicleGroupBtn").val("Save and Continue");
                            $("#createVehicleGroupBtn").prop("disabled", false);
                            $("#createAndContinueVehicleGroupBtn").prop("disabled", false);
                            $("#cancelVehicleGroupBtn").prop("disabled",false);

                        } else{

                            $("#createVehicleGroupBtn").val("Save");
                            $("#createVehicleGroupBtn").prop("disabled", false);
                            $("#createAndContinueVehicleGroupBtn").prop("disabled", false);
                            $("#cancelVehicleGroupBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-group-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }

    },

    loadVehicleGroup() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assetgroup/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {
                    self.isEdit = true;
                    self.warranty = self.year = data.content.warranty;
                    self.name = data.content.name;
                    self.code = data.content.code;
                    self.year = data.content.year;
                    self.estimatedLife = data.content.estimated_life;
                    self.statusValue = self.statusCheckBox = data.content.status;
                    console.log(data.content.vehicle_manufacturer_id);
                    if(data.content.vehicle_manufacturer_id == null) {
                        self.manufacturer_code = null;
                    }else{
                        self.manufacturer_code = {value: data.content.vehicle_manufacturer_id, text: self.titleCase(data.content.vmName + " (" + data.content.vmCode +")")};
                    }

                    if(data.content.vehicle_model_id == null) {
                        self.model_code = null;
                    }else{
                        self.model_code = {value: data.content.vehicle_model_id, text: self.titleCase(data.content.vmodelsName + " (" + data.content.vmodelsCode +")")};
                    }

                    if(data.content.vehicle_type_id == null) {
                        self.vehicle_type_code = null;
                    }else{
                        self.vehicle_type_code = {value: data.content.vehicle_type_id, text: self.titleCase(data.content.vtName + " (" + data.content.vtCode +")")};
                    }
                    if (data.content.warranty != undefined) {
                        self.selectedWarranties = data.content.warranty;
                    }else{
                        self.selectedWarranties = [];
                    }
                    if(data.content.program_id == null) {
                        self.program_id = null;
                    }else{
                        self.program_id = {value: data.content.program_id, text: data.content.prName + " | " + data.content.prDesc};
                    }

                    // if(data.content.extra_features!= '' && data.content.extra_features!= null ) {
                    //     self.featureArr=data.content.extra_features;
                    // }else{
                    //     self.loadExtraFeatures();
                    // }
                    //need to load feature from vehicle feature table
                    self.loadExtraFeatures();


                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;

                self.generateStatusCodeMessage(jqXHR,false,'asset-group-by-id')
            }
        });
    },
    loadExtraFeatures(){
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/asset/extra-feature",
            type: "GET",
            headers: this.ajxHeaders,
            data:{flag:"insert",groupId:self.groupId},
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {
                    self.featureArr = data.feature;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'asset-group-load-extra-features')
            }
        });
    },

    loadVehicleGroupData() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/assetgroup/searchAssetGroup",
           type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType: 'json',
            success: function (data) {

                if (data.status == "success") {

                    self.manufacturercodeArr = data.content.vehicle_manufacturers;
                    // self.modelcodeArr = data.content.vehicle_models;
                    self.vehicletypecodeArr = data.content.vehicle_types;

                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'vehicle-group-data-load')
            }
        });
    },

    onWarrantySelect(event) {
        var self = this;

        if (self.warranties != null) {

            if (self.selectedWarranties.length < 1) {
                self.selectedWarranties.push({
                    "text":self.warranties.text,
                    "value":self.warranties.value,
                    "id":0,
                });
            }else{
                var found = false;
                for (var i=0;i<self.selectedWarranties.length;i++) {
                    if(self.warranties != null) {
                        if(self.selectedWarranties[i] != null) {
                            if(self.selectedWarranties[i].value == self.warranties.value ){
                                found = true;
                            }
                        }
                    }
                }

                if(!found){
                    self.selectedWarranties.push({
                        "text":self.warranties.text,
                        "value":self.warranties.value,
                        "id":0,
                    });
                }
            }
        }else{
            self.selectedWarranties = [];
            self.warranties = null;
        }
    },
    removeWarranty(event,index) {
        var self = this;
        if (self.selectedWarranties[index] != null) {

            if (self.selectedWarranties[index].id == 0) {
                self.selectedWarranties.splice(index,1);
            }else{

                if (confirm('You need to remove added asset (if any) from this warranty manually from asset warranty page . Are you sure that you want to remove warranty ? ')) {

                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/assetgroup/warranty/delete",
                        type: "POST",
                        data: {'id': self.selectedWarranties[index].id},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            if (data.status == "success") {

                                setTimeout(function () {
                                    self.loadVehicleGroup();
                                },50);

                            }
                        },
                        error: function (jqXHR, exception) {
                            self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranty-delete')
                        },
                    });

                }


            }

            if (self.selectedWarranties.length < 1) {
                self.warranties = null;
            }
        }

    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/AssetGroupCreate.vue